const WIDGET_URL = window.location.hostname.endsWith('.ru')
  ? 'https://widget.whatcrm.ru'
  : 'https://widget.whatcrm.net';

export { WIDGET_URL };
